import buttonStrings from 'shared/localization/localizedStrings/ButtonStrings.en';

export default {
  accountPageTiles: {
    seeProgress: 'See progress',
    tagStatus: {
      on: 'On',
      off: 'Off',
    },
  },
  automaticSavings: {
    headerTitle: 'Automatic savings',
    sycPrimaryText: 'Save Your Change',
    sycSecondaryText: 'Round up the change from each purchase',
    sypPrimaryText: 'Save Your Pay',
    sypSecondaryText: 'Save a percentage of your direct deposits',
  },
  automaticSavingsTracker: {
    trackLabelOneTitle: 'Direct deposit so far this month',
    trackLabelTwoTitle: 'To qualify',
  },
  transactions: {
    activity: 'Your activity will be shown here',
    recentTransactions: 'Recent transactions',
    pendingText: 'Pending',
  },
  notificationBanner: {
    relinkAccountError:
      'We couldn’t start relinking your account. Please try again.',
    relinkAccountFailed:
      'We couldn’t finish relinking your account. Please try again.',
  },
  externalAccountTiles: {
    labels: {
      accountName: 'Account name',
      lastUpdated: 'Last updated',
    },
    moveMoney: 'Move money',
    hoursAgo: 'hours ago',
  },
  manageAccount: {
    safePay: 'Safe Pay',
    manageCard: 'Manage card',
    makePayment: 'Make a payment',
    cardBasics: 'Varo Believe Card basics',
    statementsAndDocuments: 'Statements and documents',
    information: 'Account details',
    payOverTime: 'Pay Over Time',
    help: 'Help',
    accountName: 'Account name',
    dialog: {
      title: 'Remove External Account',
      message: `Are you sure you want to remove {{accountName}}? You'll have to re-verify this account to use it.`,
      buttons: {
        ok: 'OK',
        cancel: 'Cancel',
        remove: 'Remove',
      },
    },
    bottomSheet: {
      bottomsheetTitle: 'Are you sure?',
      removeExternalAccountMessageCRA:
        "Removing this account could affect your eligibility for Varo Advance. Removing the account won't stop future charges if your account becomes past due.",
      removeExternalAccountMessageNonCRA:
        "If you remove this external account, you can't use it to move money. You can always relink it later or add a new card.",
    },
    buttons: {
      manageAccountLabel: 'Manage account',
      removeAccount: 'Remove account',
      accountSettingLabel: 'Account settings',
    },
    accountNumber: 'Account number',
    showAccountNumber: 'Show account number',
    routingNumber: 'Routing number',
    creditBuildingDetails: 'Credit building details',
    paymentHistory: 'Payment history',
    chargeCardAvailableToSpend: 'CHARGE_CARD_AVAILABLE_TO_SPEND',
    copiedText: 'Copied!',
    editAccountName: {
      screenTitle: 'Enter a new account name',
      saveButton: 'Save',
      saveError: 'Unable to save account name. Please try again.',
      invalidMinLength: 'Minimum 3 characters are required',
      invalidCharacters: 'Special characters are not allowed',
    },
  },
  saveYourPay: {
    headerTitle: 'Save Your Pay',
    description: 'Automatically save a percentage of each direct deposit.',
    updateButtonLabel: 'Update',
    percentLimitMessage:
      'You have {{automaticMYPSavingsPercentage}}% available to save',
  },
  openSavings: {
    openSavingsTitle: 'OPEN A VARO SAVINGS ACCOUNT',
    openSavingsButton: 'Open Savings Account',
    done: 'Done',
    skipForNow: 'Skip for now',
    fundYourSavingAccountTitle: 'Fund your savings account',
    fundMySavingsButton: 'Fund my account',
    listItems: {
      title1:
        'Enjoy an introductory{{savingsAPY}} Annual Percentage Yield (APY)',
      value1: 'Start earning high interest from your first savings deposit.',
      title2: 'Turn on automatic savings and watch your savings grow',
      value2:
        'When you turn on Save Your Pay® and Save Your Change you can start building a cushion without thinking about it.',
      title3: 'Member FDIC',
    },
    disclosure: `Annual Percentage Yield (APY) is accurate as of {{asOfDate}}. Start earning {{standardApy}} APY, then qualify to earn {{elevatedApy}} APY on your balance up to {{balanceCap}} next month by 1) Receiving direct deposit(s) totaling {{depositThreshold}} or more; and 2) Ending the month with a positive balance in all your Varo Accounts. Rates subject to change at any time.`,
    qualifyingDepositDisclosure:
      'Qualifying direct deposits are electronic deposits of your paycheck, pension or government benefits (such as Social Security or unemployment) from your employer or government agency to the extent that can be identified. Tax refunds and government stimulus payments, Person-to-Person payments (such as Venmo or Varo to Anyone), and funds deposited using a Varo routing number are not considered a direct deposit.',
    fullTerms: 'See full terms',
    agreementAccepted: 'Agreement accepted',
    notSubjectToText: 'I am not subject to',
    backupWithHold: 'Backup Withholding',
    acceptCertifyText:
      'By accepting you certify under penalty of perjury that:',
    securityNoText:
      ' the Social Security Number or Individual Taxpayer Identification Number provided is correct and;',
    notSubjectToBackholdText:
      'you are not subject to backup withholding because (1) you are exempt from backup withholding, or (2) you have not been notified by the IRS that you are subject to backup withholding, and;',
    citizenText: 'you are U.S. citizen or other U.S. person.',
    yourSavingIsApproved: 'You are on your way to living better with money!',
    fundYourSavingContent:
      'Make a transfer of any amount to start earning money from a high{{savingsAPY}} Annual Percentage Yield.',
    transferFundButton: 'Transfer funds',
    ...buttonStrings.buttons,
  },
  inviteFriends: {
    congratsText: 'congrats!',
  },
  transactionDetails: {
    title: 'Transaction detail',
    buttons: {
      sendReminder: 'Send a reminder',
      cancelTransaction: 'Cancel transaction',
    },
    rdcDetails: {
      status: 'Status',
      createdAt: 'Submitted on',
      confirmationNumber: 'Confirmation number',
      depositedTo: 'Deposited to',
      rdcFooterNote: {
        text: 'Funds are made available to you per your',
        link: {
          label: 'Varo Bank Account Agreement',
        },
      },
    },
    cancelDialog: {
      yes: 'Yes',
      no: 'No',
      confirmationText: 'Do you want to cancel the transaction?',
    },
    errorActions: {
      done: 'Done',
    },
    payOverTimeErrors: {
      unavailableTitle: "We can't open this plan",
      activeBody:
        'Your Pay Over Time plan for this purchase is active. To see its balance and payment schedule, go to your account and select Pay Over Time.',
      closedBody:
        'This purchase was paid off with Pay Over Time. To see your past plans, go to your account and select Pay Over Time.',
    },
  },
};
